import React, { useState, useEffect } from "react";
import ariesImage from "../assets/AiImage/aries.png";
import taurusImage from "../assets/AiImage/taurus1.png";
import geminiImage from "../assets/AiImage/gemini1.png";
import cancerImage from "../assets/AiImage/cancer.png";
import leoImage from "../assets/AiImage/leo.png";
import virgoImage from "../assets/AiImage/virgo.png";
import libraImage from "../assets/AiImage/libra.png";
import scorpioImage from "../assets/AiImage/scorpio.png";
import sagittariusImage from "../assets/AiImage/Sagittarius.png";
import capricornImage from "../assets/AiImage/Capricorn.png";
import aquariusImage from "../assets/AiImage/aquarius1.png";
import piscesImage from "../assets/AiImage/pisces1.png";
import { API_END_POINT } from "./Utils/Constant";
import Navbar from "../home/Navbar";
import Queryform from "./Queryform";
import Footer from "../home/Footer";

// Zodiac Mapping
const zodiacSigns = [
    "Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo",
    "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"
];

const zodiacImages = [
    { name: 'Aries', date: 'Mar 21 - Apr 19', image: ariesImage },
    { name: 'Taurus', date: 'Apr 20 - May 20', image: taurusImage },
    { name: 'Gemini', date: 'May 21 - Jun 20', image: geminiImage },
    { name: 'Cancer', date: 'Jun 21 - Jul 22', image: cancerImage },
    { name: 'Leo', date: 'Jul 23 - Aug 22', image: leoImage },
    { name: 'Virgo', date: 'Aug 23 - Sep 22', image: virgoImage },
    { name: 'Libra', date: 'Sep 23 - Oct 22', image: libraImage },
    { name: 'Scorpio', date: 'Oct 23 - Nov 21', image: scorpioImage },
    { name: 'Sagittarius', date: 'Nov 22 - Dec 21', image: sagittariusImage },
    { name: 'Capricorn', date: 'Dec 22 - Jan 19', image: capricornImage },
    { name: 'Aquarius', date: 'Jan 20 - Feb 18', image: aquariusImage },
    { name: 'Pisces', date: 'Feb 19 - Mar 20', image: piscesImage },
];

// API Endpoints for Weekly Horoscope
const zodiacAPIEndpoints = {
    Aries: `${API_END_POINT}predictions/weeklysun-aries`,
    Taurus: `${API_END_POINT}predictions/weeklysun-taurus`,
    Gemini: `${API_END_POINT}predictions/weeklysun-gemini`,
    Cancer: `${API_END_POINT}predictions/weeklysun-cancer`,
    Leo: `${API_END_POINT}predictions/weeklysun-leo`,
    Virgo: `${API_END_POINT}predictions/weeklysun-virgo`,
    Libra: `${API_END_POINT}predictions/weeklysun-libra`,
    Scorpio: `${API_END_POINT}predictions/weeklysun-scorpio`,
    Sagittarius: `${API_END_POINT}predictions/weeklysun-sagittarius`,
    Capricorn: `${API_END_POINT}predictions/weeklysun-capricorn`,
    Aquarius: `${API_END_POINT}predictions/weeklysun-aquarius`,
    Pisces: `${API_END_POINT}predictions/weeklysun-pisces`,
};

const WeeklyHoroscope = () => {
    const [selectedZodiac, setSelectedZodiac] = useState("Virgo"); // Default: Virgo
    const [horoscopeData, setHoroscopeData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);  // State to control sidebar visibility

    // Fetch horoscope data when zodiac sign changes
    useEffect(() => {
        const fetchHoroscope = async () => {
            setLoading(true);
            setError(null);

            const apiUrl = zodiacAPIEndpoints[selectedZodiac];

            try {
                const response = await fetch(apiUrl);

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                if (data && data.prediction && data.prediction.response) {
                    setHoroscopeData(data.prediction.response); // Store the response data
                } else {
                    setError("No horoscope data available.");
                    setHoroscopeData(null);
                }
            } catch (error) {
                setError("Failed to load horoscope data.");
                setHoroscopeData(null);
            } finally {
                setLoading(false);
            }
        };

        fetchHoroscope();
    }, [selectedZodiac]);

    // Find the image for the selected zodiac sign
    const selectedZodiacImage = zodiacImages.find(zodiac => zodiac.name === selectedZodiac);
    // Handle dropdown selection and scroll to the selected section
    const handleZodiacChange = (event) => {
        const selected = event.target.value;
        setSelectedZodiac(selected);

        if (selected) {
            const element = document.getElementById(`zodiac-${selected}`);
            if (element) {
                window.scrollTo({ top: element.offsetTop, behavior: "smooth" });
            }
        }
    };

    return (
        <section className="bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen">
            <Navbar />

            <h1 className="text-4xl font-bold text-center font-serif text-secondary mt-6 sm:mb-2">WEEKLY HOROSCOPE</h1>
            <p className="text-lg text-secondary p-2 max-w-2xl mx-auto text-center mb-6">
                Embrace this weekly horoscope to align your energy, discover new opportunities, and navigate any challenges that come your way in the days ahead.
            </p>
            {/* // Zodiac Dropdown (Visible only on small screens) */}
            <div className="sm:hidden px-4 mt-4">
                <label htmlFor="zodiac-select" className="block text-lg font-semibold text-center text-secondary mb-2">
                    Select Zodiac Sign:
                </label>
                <select
                    id="zodiac-select"
                    value={selectedZodiac}
                    onChange={handleZodiacChange}
                    className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-secondary"
                >
                    <option value=""> Choose a Zodiac </option>
                    {zodiacSigns.map((zodiac, index) => (
                        <option key={index} value={zodiac}>
                            {zodiac}
                        </option>
                    ))}
                </select>
            </div>

            <div className="flex flex-col lg:flex-row lg:w-4/5 sm:w-full md:w-4/5 mx-auto gap-6 lg:gap-12">
                {/* Sidebar (Hidden on small screens) */}
                <aside className="w-full lg:w-1/4 bg-slate-200 shadow-lg p-4 mt-6 h-fit sticky top-2 lg:block hidden">
                    <h2 className="text-xl font-bold text-center text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-1 mb-4">
                        Zodiac Signs
                    </h2>
                    <ul className="space-y-2">
                        {zodiacSigns.map((zodiac, index) => (
                            <li
                                key={index}
                                className="cursor-pointer p-3 rounded-md font-semibold text-center text-gray-800 hover:bg-gray-200"
                                onClick={() => window.scrollTo(0, document.getElementById(`zodiac-${zodiac}`).offsetTop)}
                            >
                                {zodiac}
                            </li>
                        ))}
                    </ul>
                </aside>
               
                {/* Main Horoscope Content */}
                <div className="lg:w-4/5 w-full lg:p-6 md:p-6 p-1 sm:p-2 sm:mt-6">
                    {loading ? (
                        <p className="text-center text-lg font-bold text-gray-600 py-10">Loading Weekly Horoscope...</p>
                    ) : error ? (
                        <p className="text-center text-lg font-bold text-red-500 py-10">{error}</p>
                    ) : horoscopeData ? (
                        <div className="bg-gradient-to-r from-white to-success/40 shadow-lg rounded-lg lg:p-6 md:p-6 p-1 sm:p-3 mb-6 ">
                            <h2 className="text-2xl font-bold text-center bg-gradient-to-r from-success to-[#9034E9] text-white p-2 rounded-md">
                                Weekly Horoscope for {selectedZodiac}
                            </h2>

                            {/* Display selected zodiac image */}
                            {selectedZodiacImage && (
                                <div className="flex flex-col items-center mt-4">
                                    <img
                                        src={selectedZodiacImage.image}
                                        alt={selectedZodiacImage.name}
                                        className="w-40 h-44 object-contain bg-bgcolor ring-4 hover:shadow-custom-shadow ring-gray-400 hover:ring-opacity-25 hover:ring-8 hover:ring-gray-300 cursor-pointer rounded-full mb-2"
                                    />
                                    <h3 className="text-lg font-semibold">{selectedZodiacImage.name}</h3>
                                    <p className="text-gray-500">{selectedZodiacImage.date}</p>
                                </div>
                            )}

                            {/* Prediction Summary */}
                            <p className="text-gray-800 bg-slate-200 rounded-md p-6 text-justify text-lg mt-2">{horoscopeData.bot_response || "No prediction available."}</p>

                            {/* Lucky Details */}
                            <div className="flex flex-wrap gap-4 mt-4">
                                <div className="p-4 bg-gray-200 rounded-md shadow-md">
                                    <strong>Lucky Color:</strong>
                                    <span className="ml-2 font-semibold" style={{ color: horoscopeData.lucky_color_code || "#000000" }}>
                                        {horoscopeData.lucky_color}
                                    </span>
                                </div>
                                <div className="p-4 bg-gray-200 rounded-md shadow-md">
                                    <strong>Lucky Numbers:</strong>
                                    <span className="ml-2 font-semibold">{horoscopeData.lucky_number.join(", ")}</span>
                                </div>
                                <div className="p-4 bg-gray-200 rounded-md shadow-md">
                                    <strong>Total Score:</strong> <span className="ml-2 font-semibold">{horoscopeData.total_score}%</span>
                                </div>
                            </div>

                            {/* Horoscope Category Scores */}
                            <div className="grid grid-cols-2 md:grid-cols-3 text-center gap-4 mt-4">
                                {["health", "career", "finances", "relationship", "travel", "family", "friends", "status"].map((category) => (
                                    horoscopeData[category] !== undefined && (
                                        <div key={category} className="bg-gradient-to-r from-success to-[#9034E9] text-white p-4 rounded-md shadow-md">
                                            <h3 className="text-lg font-semibold capitalize">{category}</h3>
                                            <p className="font-bold text-white">Score: {horoscopeData[category]}%</p>
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>
                    ) : (
                        <p className="text-center text-lg font-bold text-gray-600 py-10">No data available for {selectedZodiac}.</p>
                    )}
                </div>
            </div>

            <Queryform />
            <Footer />
        </section>
    );
};

export default WeeklyHoroscope;
